import React from "react";

export const Keynote = (props) => {
  return (
    <div id="keynote" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Keynote Speakers</h2>
          <p>The congress will feature following keynote speakers:</p>
        </div>
        <div id="row ">
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.name}-${i}`}
                  className="col-md-3 col-sm-6 keynote"
                >
                  <div className="thumbnail">
                    {" "}
                    <img src={d.img} alt="..." className="keynote-img" />
                    <div className="caption">
                      <h4>{d.name}</h4>
                      <p>{d.job}</p>
                      <h5>{d.title}</h5>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
